<template>
  <div :class="['battles-item-element', `element-${(item ? item.color : '')}`, `rarity-${casesPercent(item)}`]">
    <div v-if="item" class="element-inner">
      <div class="inner-image">
        <div class="element-rarity">
          <img :src="require(`@/assets/img/cases/rusty-${casesPercent(item)}.webp`)" />
        </div>
        <img :src="item.item.image" alt="item-image" />
      </div>
      <div class="inner-name">{{ item.item.name }}</div>
      <div class="inner-price">
        <img src="@/assets/img/icons/coin.png" alt="coins-image" />
        <div class="price-amount">
          <span>{{ generalFormatAmount(item.item.amountFixed).split('.')[0] }}</span>.{{
          generalFormatAmount(item.item.amountFixed).split('.')[1] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mixins from '@/mixins';

  export default {
    mixins: [
      mixins
    ],
    props: {
      item: Object,
      box: Object
    },
    methods: {
      casesPercent(item) {
        if (!item) return 'grey';
        if(item.item.amountFixed < this.box.amount * 0.25) {
            return 'grey'
        } else if(item.item.amountFixed < this.box.amount * 1) {
            return 'blue';
        } else if(item.item.amountFixed < this.box.amount * 2) {
            return 'purple';
        } else if(item.item.amountFixed < this.box.amount * 3) {
            return 'red';
        } else {
            return 'gold';
        }

      }
    }
  }
</script>

<style scoped>
  .battles-item-element {
    width: calc(25% - 3px);
    height: 218px;
    margin-bottom: 4px;
    margin-right: 4px;
    border-radius: 7px;
    background: linear-gradient(180deg, #1a1e29 0%, #1c202c 100%);
  }

  .battles-game.game-6 .battles-item-element {
    height: 238px;
  }

  .battles-game.game-3 .battles-item-element {
    width: calc(33.33% - 2.66px);
  }

  .battles-game.game-4 .battles-item-element {
    width: calc(50% - 2px);
  }

  .battles-game.game-6 .battles-item-element {
    width: calc(100% - 2px);
    margin-right: 0px;
  }

  .battles-game.game-2 .battles-item-element:nth-child(4n) {
    margin-right: 0;
  }

  .battles-game.game-3 .battles-item-element:nth-child(3n) {
    margin-right: 0;
  }

  .battles-game.game-4 .battles-item-element:nth-child(2n) {
    margin-right: 0;
  }

  .battles-item-element .element-inner {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 33px 20px 16px 20px;
  }

  .battles-item-element .inner-image {
    width: 108px;
    height: 108px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 42px;
    background: #1e222e;
    z-index: 0;
  }

  .battles-game.game-6 .battles-item-element .inner-image {
    width: 118px !important;
    height: 118px !important;
  }

  .battles-game.game-6 .battles-item-element .inner-image {
    width: 80px;
    height: 80px;
  }

  .battles-item-element .inner-image img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 84px;
    height: 84px;
  }

  .battles-item-element .inner-image .element-rarity {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .battles-item-element .inner-image .element-rarity::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    filter: blur(20px);
    background: radial-gradient(50% 50% at 50% 50%, rgba(150, 150, 150, .3) 0%, rgba(74, 74, 74, 0) 90%);
  }

  .battles-item-element.rarity-gold .inner-image .element-rarity::before {
    background: radial-gradient(50% 50% at 50% 50%, rgba(231, 212, 39, 0.3) 0%, rgba(74, 34, 34, 0) 90%);
  }

  .battles-item-element.rarity-red .inner-image .element-rarity::before {
    background: radial-gradient(50% 50% at 50% 50%, rgba(231, 39, 39, 0.3) 0%, rgba(128, 34, 42, 0) 90%);
  }

  .battles-item-element.rarity-purple .inner-image .element-rarity::before {
    background: radial-gradient(50% 50% at 50% 50%, rgba(172, 39, 231, .3) 0%, rgba(94, 34, 128, 0) 90%);
  }

  .battles-item-element.rarity-blue .inner-image .element-rarity::before {
    background: radial-gradient(50% 50% at 50% 50%, rgba(39, 112, 231, .3) 0%, rgba(34, 74, 128, 0) 90%);
  }

  .battles-item-element .inner-image .element-rarity img {
    width: 100%;
    height: 100%;
    opacity: 0.5;
  }

  .battles-item-element .inner-name {
    width: 100%;
    margin-top: 12px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 700;
    color: #596076;
  }

  .battles-item-element .inner-price {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }

  .battles-item-element .inner-price img {
    width: 21px;
    margin-right: 10px;
  }

  .battles-item-element .price-amount {
    font-size: 12px;
    font-weight: 700;
    color: #bbbbbb;
  }

  .battles-item-element .price-amount span {
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
  }

  @media only screen and (max-width: 1100px) {

    .battles-item-element {
      width: calc(33.33% - 2.66px);
    }

    .battles-item-element:nth-child(4n) {
      margin-right: 4px;
    }

    .battles-item-element:nth-child(3n) {
      margin-right: 0;
    }

  }
</style>